export const COLORS = {
  BRAND_PRIMARY: '#00A644',
  BRAND_TEXT: '#333',
};